import React from "react";

const ListingTitleSkeleton = () => {
  return (
    <div className="listingSection__wrap space-y-6 animate-pulse">
      {/* Badge Skeleton */}
      <div className="flex justify-between items-center">
        <div className="w-24 h-6 bg-neutral-300 rounded-md" />
      </div>

      {/* Title Skeleton */}
      <div className="h-8 w-3/4 bg-neutral-300 rounded-md" />

      {/* Location Skeleton */}
      <div className="flex items-center space-x-4">
        <span className="h-5 w-1/4 bg-neutral-300 rounded-md" />
      </div>

      {/* Divider Skeleton */}
      <div className="w-full h-px bg-neutral-200 dark:bg-neutral-700" />

      {/* Icons with Text Skeleton */}
      <div className="flex items-center xl:justify-start space-x-6 xl:space-x-8 text-sm text-neutral-700 dark:text-neutral-300">
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-neutral-300 rounded-full" />
          <span className="h-5 w-12 bg-neutral-300 rounded-md" />
        </div>
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-neutral-300 rounded-full" />
          <span className="h-5 w-12 bg-neutral-300 rounded-md" />
        </div>
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-neutral-300 rounded-full" />
          <span className="h-5 w-16 bg-neutral-300 rounded-md" />
        </div>
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-neutral-300 rounded-full" />
          <span className="h-5 w-10 bg-neutral-300 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default ListingTitleSkeleton;